if (!customElements.get('cart-drawer-recommendations')) {
  class CartDrawerRecommendations extends HTMLElement {
    /** @type {number} */
    index = 0;

    /** @type {HTMLDivElement | null} */
    track = null;

    /** @type {HTMLElement[]} */
    slides = [];

    /** @type {HTMLButtonElement | null} */
    prevBtn = null;

    /** @type {HTMLButtonElement | null} */
    nextBtn = null;

    /** @type {HTMLButtonElement | null} */
    pendingButton = null;

    constructor() {
      super();
      this.onPrev = this.onPrev.bind(this);
      this.onNext = this.onNext.bind(this);
      this.onAdd = this.onAdd.bind(this);
      this.onCartRequestEnd = this.onCartRequestEnd.bind(this);
    }

    connectedCallback() {
      this.track = this.querySelector('[data-rec-track]');
      this.slides = Array.from(this.querySelectorAll('.cart-drawer__rec-slide'));
      this.prevBtn = this.querySelector('[data-rec-prev]');
      this.nextBtn = this.querySelector('[data-rec-next]');

      this.prevBtn?.addEventListener('click', this.onPrev);
      this.nextBtn?.addEventListener('click', this.onNext);
      this.addEventListener('click', this.onAdd);
      document.addEventListener('liquid-ajax-cart:request-end', this.onCartRequestEnd);

      this.index = 0;
      this.applyTransform();
      this.updateArrows();
    }

    disconnectedCallback() {
      this.prevBtn?.removeEventListener('click', this.onPrev);
      this.nextBtn?.removeEventListener('click', this.onNext);
      this.removeEventListener('click', this.onAdd);
      document.removeEventListener('liquid-ajax-cart:request-end', this.onCartRequestEnd);
      this.clearLoading();
    }

    get maxIndex() {
      return Math.max(0, this.slides.length - 1);
    }

    applyTransform() {
      if (!this.track) {
        return;
      }

      this.track.style.transform = `translateX(-${this.index * 100}%)`;
    }

    updateArrows() {
      if (this.prevBtn) {
        this.prevBtn.disabled = this.index <= 0;
      }

      if (this.nextBtn) {
        this.nextBtn.disabled = this.index >= this.maxIndex;
      }
    }

    onPrev() {
      if (this.index <= 0) {
        return;
      }

      this.index -= 1;
      this.applyTransform();
      this.updateArrows();
    }

    onNext() {
      if (this.index >= this.maxIndex) {
        return;
      }

      this.index += 1;
      this.applyTransform();
      this.updateArrows();
    }

    /**
     * @param {HTMLButtonElement} button
     * @param {boolean} loading
     */
    setLoading(button, loading) {
      if (!button) {
        return;
      }

      if (loading) {
        if (button.dataset.wasDisabled == null) {
          button.dataset.wasDisabled = button.disabled ? 'true' : 'false';
        }

        if (!button.dataset.originalLabel) {
          button.dataset.originalLabel = button.textContent?.trim() || 'Add';
        }

        button.textContent = 'Adding…';
        button.classList.add('is-loading');
        button.setAttribute('aria-busy', 'true');
        button.disabled = true;
        return;
      }

      button.classList.remove('is-loading');
      button.setAttribute('aria-busy', 'false');
      button.disabled = button.dataset.wasDisabled === 'true';

      if (button.dataset.originalLabel) {
        button.textContent = button.dataset.originalLabel;
      }
    }

    clearLoading() {
      if (!this.pendingButton) {
        return;
      }

      this.setLoading(this.pendingButton, false);
      this.pendingButton = null;
    }

    /**
     * @param {CustomEvent} event
     */
    onCartRequestEnd(event) {
      const { requestState } = event.detail || {};

      if (!this.pendingButton) {
        return;
      }

      if (requestState?.info?.initiator !== this) {
        return;
      }

      if (requestState?.requestType !== 'add') {
        return;
      }

      this.clearLoading();
    }

    /**
     * @param {MouseEvent} event
     */
    onAdd(event) {
      const target = event.target;
      if (!(target instanceof Element)) {
        return;
      }

      const button = target.closest('.cart-drawer__rec-add');
      if (!button || !(button instanceof HTMLButtonElement)) {
        return;
      }

      if (button.disabled || button.classList.contains('is-loading') || this.pendingButton) {
        return;
      }

      if (window.liquidAjaxCart?.processing) {
        return;
      }

      const variantId = button.dataset.variantId;
      if (!variantId) {
        return;
      }

      const ajaxAdd = window.liquidAjaxCart?.add;
      if (typeof ajaxAdd !== 'function') {
        return;
      }

      this.pendingButton = button;
      this.setLoading(button, true);

      const formData = new FormData();
      formData.set('id', variantId);
      formData.set('quantity', '1');
      ajaxAdd(formData, {
        info: { initiator: this },
      });
    }
  }

  customElements.define('cart-drawer-recommendations', CartDrawerRecommendations);
}
